// packages/warning/src/utils.ts
var logged = /* @__PURE__ */ new Set();
export {
  logged
};
//# sourceMappingURL=utils.mjs.map
